<template>
  <div
    class="modal"
    data-bs-backdrop="static"
    id="kt_modal_form_emergente"
    tabindex="-1"
    aria-hidden="true"
    @keypress.esc="close"
  >
    <span
      data-bs-dismiss="modal"
      aria-label="Close"
      @click.prevent="close"
      class="svg-icon svg-icon-muted svg-icon-2hx"
      style="position: absolute; right: 30px; top: 15px; z-index: 100"
      ><svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="right: 30px; top: 15px; color: #fff"
      >
        <path
          opacity="0.3"
          d="M12 10.6L14.8 7.8C15.2 7.4 15.8 7.4 16.2 7.8C16.6 8.2 16.6 8.80002 16.2 9.20002L13.4 12L12 10.6ZM10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 8.99999 16.4 9.19999 16.2L12 13.4L10.6 12Z"
          fill="currentColor"
        />
        <path
          d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM13.4 12L16.2 9.20001C16.6 8.80001 16.6 8.19999 16.2 7.79999C15.8 7.39999 15.2 7.39999 14.8 7.79999L12 10.6L9.2 7.79999C8.8 7.39999 8.2 7.39999 7.8 7.79999C7.4 8.19999 7.4 8.80001 7.8 9.20001L10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 9 16.4 9.2 16.2L12 13.4L14.8 16.2C15 16.4 15.3 16.5 15.5 16.5C15.7 16.5 16 16.4 16.2 16.2C16.6 15.8 16.6 15.2 16.2 14.8L13.4 12Z"
          fill="currentColor"
        />
      </svg>
    </span>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mw-850px">
      <div class="modal-content" style="margin-top: 6rem;">
        <div class="modal-body" style="padding: 0px;overflow: auto;max-height: calc(100vh - 12rem);">
          <img
            @click="showing"
            v-show="!showing"
            @click.prevent="showing = true"
            style="border-radius: 5px"
            v-if="objeto.imagen"
            class="img-responsive"
            :src="objeto.imagen"
            alt="emergente"
          />
          <video
            v-show="showing"
            v-if="objeto.video"
            controls
            style="width: 100%; height: 470px"
          >
            <source :src="objeto.video" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  watch: {
    $route: function (val, old) {
      this.init();
    },
  },
  data: function () {
    return {
      popups: [],
      showing: false,
      objeto: {
        titulo: null,
        subtitulo: null,
        accion: null,
        boton: null,
        valor: null,
        imagen: null,
        imagen_segundaria: null,
        video: null,
        animacion_in: null,
        animacion_out: null,
        visible: [],
        orden: null,
        estado: true,
      },
    };
  },
  methods: {
    init() {
      let path = this.$route.fullPath;
      if (path == "/") {
        this.get("inicio");
        if (this.webconfig.valor) {
        }
      } else {
        this.get(path);
      }
    },
    get(path) {
      axios
        .get("/api/popup?query=estado.1")
        .then((response) => {
          let decode = response.decode ?? response;
          if (decode.data) {
            this.popups = decode.data.data;
            this.popups.forEach((element) => {
              //if (element.visible.indexOf(path.substr(1)) > -1) {
              if (element.visible.indexOf(path) > -1) {
                this.objeto = element;
                setTimeout(() => {
                    $('body').addClass('overflow-hidden');
                  $("#kt_modal_form_emergente").show();
                }, 1500);
                return null;
              }
            });
          }
        })
        .catch((error) => {});
    },
    close() {
      $("#kt_modal_form_emergente").hide();
      $('body').removeClass('overflow-hidden');
    },
  },
  computed: {
    ...mapState("preferencias", ["webconfig"]),
  },
};
</script>

<style>
.overflow-hidden {
    overflow: hidden;
}
.modal {
  background: rgba(0, 0, 0, 0.4);
}
</style>
